import { useState } from "react";
import { Link } from "react-router-dom"; 
import { LinkWithoutBg } from "./Links";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed w-full top-0 shadow-md bg-white z-50">
      <div className="w-full px-6 flex flex-row justify-between items-center py-4 h-16">
        <Link to="/">
          <img src="/logo.svg" alt="Logo Soluciones Hogar" className="h-9 w-auto" />
        </Link>

      <nav className="hidden md:block">
        <ul className="flex gap-6 text-center lg:gap-8 list-none m-0 p-0">
          <li>
            <LinkWithoutBg href="/#quienes-somos" className="">
               ¿Quiénes somos?
            </LinkWithoutBg>
          </li>
          <li>
            <LinkWithoutBg scroll={false} href="/servicios#todos-los-servicios" className="">
              Servicios
            </LinkWithoutBg>
          </li>
          <li>
            <LinkWithoutBg href="/preguntas-frecuentes" className="">
               Preguntas Frecuentes
            </LinkWithoutBg>
          </li>
          <li>
            <LinkWithoutBg scroll={false} href="/servicios" className="">
              Solicitar técnico
            </LinkWithoutBg>
          </li>
          <li>
            <LinkWithoutBg href="/asociarme" className="">
              Asociarme
            </LinkWithoutBg>
          </li>
        </ul>
      </nav>

      <div className="md:hidden text-3xl cursor-pointer" onClick={() => setMobileOpen(true)}>
        &#9776;
      </div>

      <div
       onClick={()=>setMobileOpen(false)}
        className={`fixed top-0 left-0 w-full min-h-screen h-full bg-white z-50 p-8 flex flex-col gap-6 transition-transform duration-400 ease-in-out overflow-y-auto ${
          mobileOpen ? "translate-x-0 opacity-100 pointer-events-auto" : "-translate-x-full opacity-0 pointer-events-none"
        }`}
      >
        <div className="absolute top-4 right-6 text-3xl cursor-pointer" onClick={() => setMobileOpen(false)}>
          &times;
        </div>
        <ul className="mt-12 list-none">
          <li className="mb-4">
            <LinkWithoutBg href="/#quienes-somos">¿Quiénes somos?</LinkWithoutBg>
          </li>
          <li className="mb-4">
            <LinkWithoutBg href="/servicios#todos-los-servicios">Servicios</LinkWithoutBg>
          </li>
          <li className="mb-4">
            <LinkWithoutBg href="/preguntas-frecuentes">Preguntas Frecuentes</LinkWithoutBg>
          </li>
          <li className="mb-4">
            <LinkWithoutBg href="servicios">Solicitar técnico</LinkWithoutBg>
          </li>
          <li className="mb-4">
            <LinkWithoutBg href="/asociarme">Asociarme</LinkWithoutBg>
          </li>
        </ul>
      </div>
      </div>
    </header>
  );
};

export default Navbar;
